import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

export const SetAdditionalOrderInformation: any = (props:any) => {
    props.dispatch({
        type: "Data/additionalOrderInformation/additionalOrderInformationLoads",
        parameter: props.parameter,
    });
};

export const chain = [SetAdditionalOrderInformation];

const AddAdditionalOrderInformation = createHandlerChainRunner(chain, "AdditionalOrderInformation");
export default AddAdditionalOrderInformation;
